export function getAppBasePath() {
  const apiHostPort = window.civiqs.config.API_HOST_PORT;

  return window.location.protocol + '//' + apiHostPort;
}
